export default __webpack_public_path__ + "static/media/labelMarocain.57d56093.png";